export default __webpack_public_path__ + "static/media/back-left.2421bea7.svg";